import {IRange} from "@pg-design/range-module";

import {ISearchFiltersFormValues} from "../../types/ISearchFiltersFormValues";
import {ISearchFiltersSlot} from "../../types/ISearchFiltersSlot";

export const validateFilterError = (formValues: ISearchFiltersFormValues, filtersSlots: ISearchFiltersSlot[]): boolean => {
    return filtersSlots.some((filterSlot) => {
        const filterConfig = filterSlot.filters[0];
        // Validation for area filter
        if (filterConfig.id === "area") {
            const areaValue = formValues[filterSlot.id as keyof ISearchFiltersFormValues] as IRange<string>;
            const lowerValue = parseFloat(areaValue.lower ?? "");
            const upperValue = parseFloat(areaValue.upper ?? "");
            return !isNaN(lowerValue) && !isNaN(upperValue) && lowerValue > upperValue;
        }
        return false;
    });
};
import {IRange} from "@pg-design/range-module";

import {ISearchFiltersFormValues} from "../../types/ISearchFiltersFormValues";
import {ISearchFiltersSlot} from "../../types/ISearchFiltersSlot";

export const validateFilterError = (formValues: ISearchFiltersFormValues, filtersSlots: ISearchFiltersSlot[]): boolean => {
    return filtersSlots.some((filterSlot) => {
        const filterConfig = filterSlot.filters[0];
        // Validation for area filter
        if (filterConfig.id === "area") {
            const areaValue = formValues[filterSlot.id as keyof ISearchFiltersFormValues] as IRange<string>;
            const lowerValue = parseFloat(areaValue.lower ?? "");
            const upperValue = parseFloat(areaValue.upper ?? "");
            return !isNaN(lowerValue) && !isNaN(upperValue) && lowerValue > upperValue;
        }
        return false;
    });
};
